

export const email = "admin@alternadevstudio.com";

export const mailtoHref = "mailto:" + email;

//# sourceMappingURL=SupportContact.js.map
